import angular from 'angular';
import apiEndpoints from './api-endpoints.component';

export default angular.module('eshq.apiEndpoints', [])
  .component('eshqApiEndpoints', apiEndpoints)
  .name;



// WEBPACK FOOTER //
// ./ui/src/components/api-endpoints/api-endpoints.js